import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Container,
  Paper,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import {
  SUPPORT_PAGE_TITLE,
  SUPPORT_PAGE_SUBTITLE,
  SUPPORT_CONTACTS,
} from "../../content/supportContent";

const mailto = (email: string) => `mailto:${email}`;

export const SupportView: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        py: 3,
        bgcolor: "bg.main",
      }}
    >
      <Container maxWidth="md">
        <MuiLink
          component={Link}
          to="/login"
          sx={{ display: "inline-block", mb: 2 }}
        >
          ← Tillbaka till inloggning
        </MuiLink>
        <Typography variant="h4" component="h1" color="primary" gutterBottom>
          {SUPPORT_PAGE_TITLE}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 3 }}
        >
          {SUPPORT_PAGE_SUBTITLE}
        </Typography>
        {SUPPORT_CONTACTS.map((section) => (
          <Paper
            key={section.sectionTitle}
            elevation={1}
            sx={{ p: 3, mb: 2, borderRadius: 2 }}
          >
            <Typography variant="h6" color="primary" gutterBottom>
              {section.sectionTitle}
            </Typography>
            {section.contacts.map((contact) => (
              <Box key={contact.email} sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {contact.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {contact.description}
                </Typography>
                <MuiLink
                  href={mailto(contact.email)}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ display: "inline-block", mt: 0.5 }}
                >
                  {contact.email}
                </MuiLink>
              </Box>
            ))}
          </Paper>
        ))}
      </Container>
    </Box>
  );
};
